<script>
/* eslint-disable */
import {UFakeLoader} from 'uloc-vue'
import ConsoleMenuItem from "components/console/components/MenuItem.vue"

export default {
  name: 'WebsitePage',
  provide: function () {
    return {
      page: this,
    }
  },
  mixins: [
    //DefaultMixin,
  ],
  components: {
    ConsoleMenuItem,
    //MenuLeilao,
    UFakeLoader
  },
  data() {
    return {
      hideMenu: false,
      active: 'hom',
      menu: [
        {name: 'sites', label: 'Sites', icon: 'fal fa-browser', route: 'website.sites.lista'},
        /*{name: 'menus', label: 'Menus', icon: 'fal fa-bars', route: 'website.menus.page'},*/
        {name: 'banners', label: 'Banners e Popup', icon: 'fal fa-image', route: 'website.banners'},
        {name: 'paginas', label: 'Páginas', icon: 'fal fa-page', route: 'website.paginas'},
        {name: 'blog', label: 'Blog', icon: 'fal fa-blog', route: 'website.blog.posts'},
      ],
    }
  },
  computed: {
    bindCss() {
      const css = []
      this.hideMenu && css.push('folded')
      return css
    }
  },
  mounted() {
    document.body.classList.add('app-leilao-body')
  },
  beforeDestroy() {
    document.body.classList.remove('app-leilao-body')
  },
  destroyed() {
    // document.querySelector('.u-erp-layout-container').classList.remove('bg-white')
  },
  methods: {
    setActive(v) {
      this.active = v
    },
    bindClick() {
      if (!this.hideMenu) return
      this.hideMenu = false
    }
  },
  meta: {
    title: 'Leilão',
    name: 'Leilão'
  }
}
</script>

<template>
  <div class="leilao-page-container">
    <div class="ev2-menu w-menub leilao-menu min compact" :class="bindCss" @click="bindClick">
      <div class="def-width">
<!--        <div class="content destaq">
          <div class="tab m-l-lg">
            <div class="title">Sites</div>
            <div class="val">0</div>
          </div>
          <div class="tab">
            <div class="title">Banners</div>
            <div class="val">0</div>
          </div>
          <div class="tab">
            <div class="title">Publicações</div>
            <div class="val">0</div>
          </div>
          <div class="tab full text-right">
            <a @click.stop.prevent="hideMenu = true" class="font-10 text-grey">Ocultar menu</a>
          </div>
        </div>-->
        <div class="menu-bottom content-menu">
          <console-menu-item
              v-for="m in menu"
              :key="m.name"
              :name="m.name"
              :icon="m.icon"
              :label="m.label"
              :route="m.route"
              :disabled="m.disabled"
              :parent-route="m.parentRoute"
          />
        </div>
      </div>
    </div>
    <div class="flex col-grow no-wrap leilao-page">
      <div class="app-layout-cmenu" style="padding-right: 0">
        <transition name="slide" appear>
          <div class="transition-generic">
            <router-view/>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<style lang="stylus" src="../../leiloes/components/leilao.styl"/>
